import { render } from "./DiamondDetailCaratSize.vue?vue&type=template&id=39162d20&ts=true"
import script from "./DiamondDetailCaratSize.vue?vue&type=script&lang=ts"
export * from "./DiamondDetailCaratSize.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__